import ChessRestClient from '@/Api/ChessRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useGetAvailableSlots(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  type AvailableSlotsResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<
    AvailableSlotsResponse,
    Error,
    {
      coach_user_id: string;
      current_date?: string;
      weeks?: string;
      reschedule_type?: string;
      session_id?: number;
    }
  >(
    async filters => {
      const queryParams = new URLSearchParams();
      // Add all filters, handling reschedule_type
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, String(value));
        }
      });
      const queryString = queryParams.toString();
      const response = await ChessRestClient.get(
        `subscription/v1/sessions/coach-available-slots?${queryString}`,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
